export default __webpack_public_path__ + "static/media/maestroMob.92ccd2a6.svg";